import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5ae009e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1))
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_12 = { href: "#" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_15 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = { class: "d-flex flex-wrap flex-stack flex-resume" }
const _hoisted_18 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_19 = { class: "d-flex flex-wrap" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "svg-icon svg-icon-3 svg-icon-success me-2" }
const _hoisted_22 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_23 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_24 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_25 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_26 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_27 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_28 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_avatar, {
                size: "80",
                fullname: _ctx.store.getters.currentUser.nombreProveedor,
                color: "#005E8A"
              }, null, 8, ["fullname"]),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.store.getters.currentUser.nombreProveedor), 1),
                  _createElementVNode("a", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("a", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.store.getters.currentUser.contactoEmail), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters.allDashboard, (estado) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: estado.id,
                      class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 content-box"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                        ]),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatCurrency(estado.monto)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(estado.nombre), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("ul", _hoisted_25, [
            (_ctx.currentUser.rol == _ctx.Roles.USUARIO)
              ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                  _createVNode(_component_router_link, {
                    to: "/crafted/pages/profile/overview",
                    class: "nav-link text-active-primary me-6",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Facturas ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentUser.rol == _ctx.Roles.USUARIO)
              ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: { name: 'payment-conditions' },
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Modalidad de Pago ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_28, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: { name: 'profile-info' },
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Información de Contacto ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}